import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      {/* Header */}
      <header className="header">
        <div className="container">
          <div className="nav">
            <div className="logo">
              <div className="logo-main">
                <span className="logo-text">Shopifyudvikler.dk</span>
                                <div className="shopify-partner-badge">
                  <svg width="80" height="24" viewBox="0 0 500 142.8" xmlns="http://www.w3.org/2000/svg">
                    <g>
                      <g>
                        <path fill="#95BF47" d="M107.4,27.1c-0.1-0.7-0.7-1.1-1.2-1.1c-0.5,0-10.4-0.2-10.4-0.2s-8.3-8-9.1-8.9c-0.8-0.8-2.4-0.6-3-0.4
                          c0,0-1.6,0.5-4.2,1.3c-0.4-1.4-1.1-3.1-2-4.9c-2.9-5.6-7.3-8.6-12.5-8.6c0,0,0,0,0,0c-0.4,0-0.7,0-1.1,0.1
                          c-0.2-0.2-0.3-0.4-0.5-0.5c-2.3-2.4-5.2-3.6-8.7-3.5c-6.7,0.2-13.4,5.1-18.9,13.7c-3.8,6.1-6.7,13.7-7.6,19.6
                          c-7.7,2.4-13.1,4.1-13.3,4.1c-3.9,1.2-4,1.3-4.5,5C10.2,45.6,0,124.5,0,124.5l85.6,14.8l37.1-9.2
                          C122.6,130.1,107.5,27.8,107.4,27.1z M75.2,19.2c-2,0.6-4.2,1.3-6.6,2.1c0-3.4-0.5-8.2-2-12.2C71.7,9.9,74.2,15.7,75.2,19.2z
                           M64.1,22.6c-4.5,1.4-9.4,2.9-14.3,4.4c1.4-5.3,4-10.5,7.2-14c1.2-1.3,2.9-2.7,4.8-3.5C63.8,13.4,64.2,18.9,64.1,22.6z M54.9,4.9
                          c1.6,0,2.9,0.3,4,1.1c-1.8,0.9-3.6,2.3-5.2,4.1c-4.3,4.6-7.6,11.7-8.9,18.6c-4.1,1.3-8.1,2.5-11.7,3.6
                          C35.5,21.4,44.6,5.2,54.9,4.9z"/>
                        <g>
                          <path fill="#5E8E3E" d="M106.2,26c-0.5,0-10.4-0.2-10.4-0.2s-8.3-8-9.1-8.9c-0.3-0.3-0.7-0.5-1.1-0.5l0,122.9l37.1-9.2
                            c0,0-15.1-102.3-15.2-103C107.3,26.4,106.7,26,106.2,26z"/>
                          <path fill="#FFFFFF" d="M65,45.1l-4.3,16.1c0,0-4.8-2.2-10.5-1.8c-8.4,0.5-8.4,5.8-8.4,7.1c0.5,7.2,19.4,8.8,20.5,25.7
                            c0.8,13.3-7,22.4-18.4,23.1C30.3,116,22.8,108,22.8,108l2.9-12.3c0,0,7.6,5.7,13.6,5.3c3.9-0.2,5.4-3.5,5.2-5.7
                            c-0.6-9.4-16-8.8-17-24.3C26.7,58,35.2,44.9,54,43.7C61.3,43.2,65,45.1,65,45.1z"/>
                        </g>
                      </g>
                      <g>
                        <path fill="#000" d="M172.9,79.4c-4.3-2.3-6.5-4.3-6.5-7c0-3.4,3.1-5.6,7.9-5.6c5.6,0,10.6,2.3,10.6,2.3l3.9-12
                          c0,0-3.6-2.8-14.2-2.8c-14.8,0-25.1,8.5-25.1,20.4c0,6.8,4.8,11.9,11.2,15.6c5.2,2.9,7,5,7,8.1c0,3.2-2.6,5.8-7.4,5.8
                          c-7.1,0-13.9-3.7-13.9-3.7l-4.2,12c0,0,6.2,4.2,16.7,4.2c15.2,0,26.2-7.5,26.2-21C185,88.4,179.5,83.2,172.9,79.4z"/>
                        <path fill="#000" d="M233.5,54.1c-7.5,0-13.4,3.6-17.9,9l-0.2-0.1l6.5-34h-16.9l-16.5,86.6h16.9l5.6-29.6
                          c2.2-11.2,8-18.1,13.4-18.1c3.8,0,5.3,2.6,5.3,6.3c0,2.3-0.2,5.2-0.7,7.5l-6.4,33.9h16.9l6.6-35c0.7-3.7,1.2-8.1,1.2-11.1
                          C247.4,59.9,242.4,54.1,233.5,54.1z"/>
                        <path fill="#000" d="M285.7,54.1c-20.4,0-33.9,18.4-33.9,38.9c0,13.1,8.1,23.7,23.3,23.7c20,0,33.5-17.9,33.5-38.9
                          C308.7,65.7,301.6,54.1,285.7,54.1z M277.4,103.8c-5.8,0-8.2-4.9-8.2-11.1c0-9.7,5-25.5,14.2-25.5c6,0,8,5.2,8,10.2
                          C291.4,87.8,286.3,103.8,277.4,103.8z"/>
                        <path fill="#000" d="M352,54.1c-11.4,0-17.9,10.1-17.9,10.1h-0.2l1-9.1h-15c-0.7,6.1-2.1,15.5-3.4,22.5l-11.8,62h16.9
                          l4.7-25.1h0.4c0,0,3.5,2.2,9.9,2.2c19.9,0,32.9-20.4,32.9-41C369.5,64.3,364.4,54.1,352,54.1z M335.8,104c-4.4,0-7-2.5-7-2.5
                          l2.8-15.8c2-10.6,7.5-17.6,13.4-17.6c5.2,0,6.8,4.8,6.8,9.3C351.8,88.4,345.3,104,335.8,104z"/>
                        <path fill="#000" d="M393.7,29.8c-5.4,0-9.7,4.3-9.7,9.8c0,5,3.2,8.5,8,8.5h0.2c5.3,0,9.8-3.6,9.9-9.8
                          C402.1,33.4,398.8,29.8,393.7,29.8z"/>
                        <polygon fill="#000" points="370,115.5 386.9,115.5 398.4,55.5 381.4,55.5"/>
                        <path fill="#000" d="M441.5,55.4h-11.8l0.6-2.8c1-5.8,4.4-10.9,10.1-10.9c3,0,5.4,0.9,5.4,0.9l3.3-13.3
                          c0,0-2.9-1.5-9.2-1.5c-6,0-12,1.7-16.6,5.6c-5.8,4.9-8.5,12-9.8,19.2l-0.5,2.8h-7.9l-2.5,12.8h7.9l-9,47.4h16.9l9-47.4h11.7
                          L441.5,55.4z"/>
                        <path fill="#000" d="M482.3,55.5c0,0-10.6,26.7-15.3,41.3h-0.2c-0.3-4.7-4.2-41.3-4.2-41.3h-17.8l10.2,55.1
                          c0.2,1.2,0.1,2-0.4,2.8c-2,3.8-5.3,7.5-9.2,10.2c-3.2,2.3-6.8,3.8-9.6,4.8l4.7,14.4c3.4-0.7,10.6-3.6,16.6-9.2
                          c7.7-7.2,14.9-18.4,22.2-33.6L500,55.5H482.3z"/>
                      </g>
                    </g>
                  </svg>
                </div>
              </div>
              <span className="logo-subtitle">Erik Lindberg - Full Stack Shopify Udvikler</span>
            </div>
            <div className="header-pricing">
              <div className="pricing-info">
                <span className="header-rate">600 kr/time</span>
                <span className="header-message">Uden binding</span>
              </div>
              <a href="mailto:postlindberg74@gmail.com" className="btn btn-primary">Få et tilbud</a>
            </div>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero">
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <div className="hero-badge">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L14.5 8.5L21 11L14.5 13.5L12 20L9.5 13.5L3 11L9.5 8.5L12 2Z" fill="#00A651"/>
                </svg>
                Shopify Specialist
              </div>
              <h1>Shopify-udvikling med blik for både kodning og forretning</h1>
              <p className="hero-subtitle">
                Hej – jeg hedder Erik, og jeg hjælper danske e-commerce virksomheder med at få det maksimale ud af deres Shopify-setup.
                Uanset om du har en mindre webshop eller sidder i en større virksomhed som Head of Digital, så kan jeg hjælpe med alt fra udvikling af temaer og apps til komplekse integrationer med ERP og PIM-systemer.
              </p>
              <p className="hero-description">
                Jeg arbejder som konsulent – fleksibelt, ærligt og med fokus på det, der skaber værdi.
              </p>
              <div className="hero-buttons">
                <a href="#services" className="btn btn-primary btn-large">Se hvad jeg kan hjælpe med</a>
                <a href="#about" className="btn btn-outline btn-large">Læs mere om mig</a>
              </div>
            </div>
            <div className="hero-image">
              <img 
                src="/erik-profile.png" 
                alt="Erik Lindberg - Shopify Udvikler" 
                className="hero-profile-image"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Agentic Commerce Section */}
      <section className="agentic-commerce">
        <div className="container">
          <div className="agentic-content">

            <h2>Agentic Commerce – er I kommet i gang endnu?</h2>
            <p className="agentic-intro">
              Agentic Commerce er ikke længere fremtidsteknologi – det er virkelighed. AI-agenter, der kan handle selvstændigt, 
              personalisere kundeoplevelser i realtid og optimere hele købsprocessen.
            </p>
            <p className="agentic-description">
              Mens andre stadig taler om det, bygger jeg allerede løsninger. Fra intelligente chatbots der kan gennemføre salg, 
              til AI-drevne produktanbefalinger og automatisk inventory management.
            </p>
            <div className="agentic-cta">
              <p><strong>Vil du vide, hvordan Agentic Commerce kan give jer et forspring?</strong></p>
              <a href="mailto:postlindberg74@gmail.com" className="btn btn-primary btn-large">Lad os tale om jeres muligheder</a>
            </div>
          </div>
        </div>
      </section>

      {/* Why Shopify Specialist Section */}
      <section className="why-specialist">
        <div className="container">
          <h2>Hvorfor samarbejde med en Shopify Specialist?</h2>
          
          <div className="specialist-content">
            <p>Shopify er en fremragende e-commerce platform – men den kommer med både styrker og begrænsninger.</p>
            <p>Derfor er det vigtigt at arbejde sammen med en udvikler, der ikke bare kan kode, men også kender platformens muligheder og faldgruber.</p>
            
            <ul className="expertise-list">
              <li>
                <strong>Jeg kender forskellen på Basic og Plus</strong>
                – og hvordan man bedst udnytter begge versioner
              </li>
              <li>
                <strong>Jeg ved, hvor Shopify er stærk</strong>
                – og hvor man skal være kreativ for at få det til at virke
              </li>
              <li>
                <strong>Jeg kender apps og custom-løsninger</strong>
                – hvilke 3. parts apps der faktisk virker, og hvornår det er bedre at kode selv
              </li>
              <li>
                <strong>Jeg bygger skalerbare løsninger</strong>
                – så du undgår at bruge tid og penge på noget, der ikke holder
              </li>
            </ul>
            
            <p className="specialist-conclusion">Kort sagt: Jeg hjælper dig med at træffe de rigtige tekniske valg fra starten – så du slipper for dyre omveje senere.</p>
          </div>
        </div>
      </section>

      <section className="why-choose-me">
        <div className="container">
          <h2>Hvorfor vælge mig – og ikke et bureau?</h2>
          
          <div className="choose-content">
            <p className="choose-intro">Når du arbejder med mig, får du direkte adgang til den, der faktisk laver arbejdet. Ingen projektledere, kontorhusleje eller frokostordninger – bare en erfaren Shopify-udvikler, der er 100% fokuseret på at bygge løsninger, der virker.</p>
            
            <div className="benefits-wrap">
              <h3>Det betyder:</h3>
              <ul className="benefits-list">
                <li><strong>Fleksibilitet</strong> – hurtige beslutninger og tæt samarbejde uden mellemled</li>
                <li><strong>Lavere omkostninger</strong> – du betaler ikke for kontor, administration eller aktieudbytte</li>
                <li><strong>Mere nærvær</strong> – jeg er tæt på din forretning og engageret i dit projekt</li>
                <li><strong>Effektiv udvikling</strong> – jeg laver ikke andet end Shopify og har bygget alt fra små nichebutikker til komplekse løsninger med integrationer til fx Business Central</li>
              </ul>
            </div>
            
            <p className="choose-conclusion">Du får med andre ord mere for pengene – og en samarbejdspartner, der forstår både kodning og forretning.</p>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <div className="container">
          <h2>Hvad jeg kan hjælpe med</h2>
          <p className="section-subtitle">Her er nogle af de opgaver, jeg typisk løser for mine kunder:</p>
          
          <div className="services-grid">
            <div className="service-category">
              <h3>Shopify udvikling og optimering</h3>
              <ul>
                <li>Udvikling af custom temaer og sektioner (Liquid + metafields + JSON templates)</li>
                <li>Optimering af eksisterende temaer – hastighed, UX, mobile performance</li>
                <li>Checkout logik, cart scripts og automatiseringer</li>
              </ul>
            </div>
            
            <div className="service-category">
              <h3>Integrationer</h3>
              <ul>
                <li>ERP-systemer (fx Business Central 365, Economic, SAP)</li>
                <li>PIM-løsninger</li>
                <li>Fragt og logistik</li>
                <li>POS og lagerstyring</li>
                <li>Custom API-integrationer (REST, GraphQL)</li>
              </ul>
            </div>
            
            <div className="service-category">
              <h3>Teknisk rådgivning</h3>
              <ul>
                <li>Vurdering af 3. parts apps vs. custom udvikling</li>
                <li>Planlægning og arkitektur af nye shops og features</li>
                <li>Fejlfinding og teknisk sparring</li>
              </ul>
            </div>
            
            <div className="service-category">
              <h3>Backend / Fullstack udvikling</h3>
              <ul>
                <li>Liquid, React, Node.js, Javascript, PHP, Remix mm.</li>
                <li>Shopify Admin API og Storefront API</li>
                <li>Webhooks og automatiske workflows</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Common Challenges Section */}
      <section className="challenges">
        <div className="container">
          <h2>Kender du nogle af disse udfordringer?</h2>
          
          <div className="challenges-grid">
            <div className="challenge-item">
              <div className="challenge-quote">
                "Vores checkout skal noget særligt – men det er begrænset, hvad vi kan ændre i Shopify."
              </div>
              <div className="challenge-solution">
                → Jeg hjælper dig med at finde workarounds eller anbefale en løsning, der overholder reglerne og virker.
              </div>
            </div>
            
            <div className="challenge-item">
              <div className="challenge-quote">
                "Vi har mange manuelle processer – kan det automatiseres?"
              </div>
              <div className="challenge-solution">
                → Ofte ja. Jeg har lavet alt fra produktimport og prislogik til automatiseret synkronisering med eksterne systemer.
              </div>
            </div>
            
            <div className="challenge-item">
              <div className="challenge-quote">
                "Vi arbejder meget med de sectioner der kommer med vores Shopify tema – men vi mangler nogle custom function som f.eks hyperlinks på billeder.
              </div>
              <div className="challenge-solution">
                → Jeg bygger de manglende custom sektioner/blocks – så I kan styre det direkte i Theme Editor.
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <h2>Fra mursten til kode – lidt om mig</h2>
          <div className="about-content">
            <div className="about-text">
              <p>Jeg har ikke altid været udvikler.</p>
              <p>Før jeg begyndte at kode, arbejdede jeg med salg, ledelse og som selvstændig indenfor ejendomshandel og byggeri. Det var spændende, men ikke helt mig.</p>
              <p>Det ændrede sig, da jeg begyndte at kode. Pludselig gav det hele mening.</p>
              <p>Det med at bygge noget fra bunden. Løse problemer. Se tingene hænge sammen.</p>
              <p>Det minder utroligt meget om at renovere et hus – men i stedet for mursten bygger jeg med funktionalitet og logik.</p>
              <p><strong>I dag kombinerer jeg min tekniske kunnen med en solid forståelse for forretning. Og det gør en forskel.</strong></p>
              <p className="about-cta">Vil du høre mere om, hvordan jeg kan hjælpe din virksomhed? <a href="mailto:postlindberg74@gmail.com" className="inline-link">Send mig en mail</a>.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials">
        <div className="container">
          <h2>Hvad siger mine kunder?</h2>
          
          <div className="testimonials-grid">
            <div className="testimonial">
              <div className="testimonial-content">
                "Erik var en kæmpe hjælp i vores migration fra WooCommerce til Shopify. Han spottede flere potentielle problemer, før vi selv gjorde – og sparede os for mange timer og tusindvis af kroner."
              </div>
              <div className="testimonial-author">
                <strong>Line M.</strong>, E-commerce Manager
              </div>
            </div>
            
            <div className="testimonial">
              <div className="testimonial-content">
                "Vi har brugt mange udviklere før, men Erik er den første, der forstod vores forretning og kunne levere noget, der rent faktisk fungerede i praksis."
              </div>
              <div className="testimonial-author">
                <strong>Thomas V.</strong>, Founder og direktør
              </div>
            </div>
          </div>
          
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq">
        <div className="container">
          <h2>Ofte stillede spørgsmål</h2>
          
          <div className="faq-grid">
            <div className="faq-item">
              <h3>🛒 Hvad koster det at få hjælp til Shopify?</h3>
              <p>Det afhænger af opgaven, men jeg arbejder oftest på timebasis eller fast pris for større opgaver. Kontakt mig for en snak – så får du et klart estimat.</p>
            </div>
            
            <div className="faq-item">
              <h3>🔧 Kan du hjælpe med integration til Business Central 365?</h3>
              <p>Ja – jeg har erfaring med integration til flere ERP-systemer, inkl. BC365. Både via API, middleware eller filbaseret udveksling.</p>
            </div>
            
            <div className="faq-item">
              <h3>🛍️ Kan du sætte en Shopify-shop op og hjælpe med design?</h3>
              <p>Ja. Jeg kan hjælpe med opsætningen af jeres shop, og jeg samarbejder med en designer, der altid gerne giver et tilbud på design-delen.</p>
            </div>
            
            <div className="faq-item">
              <h3>📦 Kan du bygge en Shopify app til os?</h3>
              <p>Ja – jeg udvikler også private apps til internt brug, med integration til fx eksterne systemer, avanceret logik eller brugerdefinerede funktioner.</p>
            </div>
            
            <div className="faq-item">
              <h3>👨‍💻 Arbejder du onsite eller remote?</h3>
              <p>Primært remote, men jeg møder gerne fysisk op til møder, workshops eller projektstart, hvis det giver mening.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <h2>Klar til at tage næste skridt?</h2>
          <p>Uanset om du har en konkret opgave eller bare gerne vil vende en idé, så er du velkommen til at tage kontakt.</p>
          
          <div className="cta-actions">
            <a href="mailto:postlindberg74@gmail.com" className="btn btn-outline btn-large">📩 Skriv til mig!</a>
          </div>
          
          <p className="cta-closing"><strong>Jeg glæder mig til at høre om dit projekt</strong><br />– Erik</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-brand">

              <p>Shopify Udvikling med blik for både kodning og forretning</p>
              <div className="address">
                <p>VELS</p>
                <p>Gl hovedgade 14, 2</p>
                <p>2970 Hørshold</p>
                <p>Tlf: <a href="tel:+4561542728">61 54 27 28</a></p>
                <p>CVR: 45804739</p>
              </div>
            </div>
            <div className="footer-links">
              <a href="mailto:postlindberg74@gmail.com">Kontakt</a>
              <a href="https://www.linkedin.com/in/erik-lindberg-164ba118b/">LinkedIn</a>
            </div>
          </div>
          <div className="footer-bottom">
            <p>&copy; 2024 Erik Lindberg - Shopify Udvikler | shopifyudvikler.dk</p>
          </div>
        </div>
      </footer>
    </div>
  );
}

export default App;